var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Dark",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 299.3 69",
    style: {
      enableBackground: "new 0 0 299.3 69"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFCBB;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{fill:url(#SVGID_3_);}\r\n\t.st5{fill:#666666;}\r\n\t.st6{fill:url(#SVGID_4_);}\r\n\t.st7{fill:url(#SVGID_5_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Title"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.1,58.6c0,0,200.2,0,190.5,1.3c-0.8,0.1-149.1,0.8-185.7,3.8C79.7,63.9,77.1,58.6,77.1,58.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.071,
    y1: 583.71,
    x2: 137.071,
    y2: 542.5,
    gradientTransform: "matrix(1 0 0 1 0 -518)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFCBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFCBD"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.9,55.5h3.9l-1.9-31h-5.1l-5.5,15c-1.4,3.9-2.5,7.3-3.3,10.5h-0.1c-0.8-3.2-1.8-6.6-3.1-10.5l-5.3-15h-5.1 l-2.2,31H81l0.8-13.3c0.3-4.7,0.5-9.9,0.6-13.7h0.1c0.9,3.7,2.1,7.7,3.6,12.1l5,14.8h3l5.5-15.1c1.6-4.3,2.9-8.1,3.9-11.8h0.1 c-0.1,3.9,0.2,9.1,0.5,13.4L104.9,55.5z M110.8,33.2l8.3,20.5c0.1,0.3,0.2,0.7,0.3,1.1c0,0.3-0.2,0.7-0.3,1 c-0.8,1.7-1.9,3.3-3.4,4.5c-1,0.9-2.2,1.6-3.5,2l1,3.4c1.9-0.4,3.6-1.3,5-2.6c2.8-2.4,4.7-6.3,7.6-14l6.1-15.9h-4.3l-4.4,13.1 c-0.6,1.6-1,3.3-1.4,4.7h-0.1c-0.4-1.3-0.9-3.1-1.4-4.5l-4.9-13.2H110.8z M138.6,55.5V42.3c0-5.2-0.1-8.9-0.3-12.8h0.1 c1.7,3.6,3.7,7,5.8,10.4l9.9,15.7h4.1v-31h-3.8v13c0,4.8,0.1,8.6,0.5,12.8h-0.1c-1.6-3.5-3.5-6.9-5.6-10.1l-10-15.7h-4.3v31 L138.6,55.5z M181.8,45.1c0.1-0.6,0.1-1.3,0.1-1.9c0-4.1-1.9-10.5-9.2-10.5c-6.5,0-10.4,5.3-10.4,12s4.1,11.2,11,11.2 c2.5,0.1,5.1-0.4,7.4-1.4l-0.7-2.9c-1.9,0.8-4.1,1.2-6.2,1.2c-4,0-7.6-2.3-7.6-7.7L181.8,45.1z M166.2,42.2 c0.3-2.8,2.1-6.6,6.2-6.6c4.6,0,5.7,4,5.6,6.6H166.2z M187.2,27.9v5.3h-3.4v3.1h3.4v12.2c0,2.6,0.4,4.6,1.6,5.8 c1.1,1.2,2.7,1.8,4.4,1.7c1.2,0,2.4-0.1,3.6-0.5l-0.2-3c-0.8,0.2-1.6,0.3-2.4,0.3c-2.3,0-3-1.6-3-4.3v-12h5.8v-3.2h-5.8v-6.4 L187.2,27.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200,55.4c2.5,0.3,5.1,0.4,7.6,0.4c6,0,11-1.4,14-4.2c2.9-2.7,4.8-6.8,4.8-12.3c0-5.3-1.8-9-4.8-11.4 s-6.9-3.6-12.7-3.6c-3,0-6,0.2-9,0.6L200,55.4z M205.7,29c1.3-0.2,2.6-0.4,3.9-0.3c7.1,0,11.1,3.9,11,10.8 c0,7.9-4.4,11.9-11.7,11.9c-1,0-2.1,0-3.1-0.1L205.7,29z M235.8,55.5V33.1h-5.7v22.4L235.8,55.5z M232.9,23.8 c-1.7-0.1-3.1,1.2-3.2,2.8c0,0.1,0,0.2,0,0.3c0,1.8,1.4,3.2,3.2,3.2c1.8,0,3.2-1.4,3.2-3.2c0-1.7-1.3-3-2.9-3.1 C233.1,23.8,233,23.8,232.9,23.8L232.9,23.8L232.9,23.8z M258.3,55.5c-0.2-1.8-0.3-3.6-0.3-5.4V42c0-4.9-2.1-9.4-9.3-9.4 c-2.8-0.1-5.6,0.6-8.1,2l1.1,3.7c1.8-1.1,3.9-1.7,6-1.7c3.9,0,4.6,2.4,4.6,3.9v0.4c-8.3,0-13.3,2.8-13.3,8.5c0,3.7,3,6.7,6.6,6.7 c0.2,0,0.3,0,0.5,0c2.6,0.1,5-1,6.6-3h0.1l0.4,2.5L258.3,55.5z M252.5,47.7c0,0.4-0.1,0.8-0.2,1.2c-0.6,1.9-2.4,3.1-4.4,3.1 c-1.7,0.1-3.1-1.1-3.2-2.8c0-0.2,0-0.3,0-0.5c0-3.4,3.8-4.3,7.8-4.2L252.5,47.7L252.5,47.7z M262.9,55.5h5.7V43.9 c0-0.6,0.1-1.2,0.2-1.8c0.4-2.5,2.5-4.3,5.1-4.3c0.6,0,1.1,0.1,1.7,0.2v-5.3c-0.4-0.1-0.9-0.1-1.4-0.1c-2.9,0.1-5.3,2-6.1,4.8h-0.2 l-0.2-4.3h-4.9c0.1,2,0.2,4.2,0.2,7.2L262.9,55.5z M276.8,33.1l8.2,20.6c0.2,0.3,0.3,0.7,0.3,1.1c0,0.4-0.2,0.7-0.4,1 c-0.7,1.4-1.8,2.6-3.1,3.5c-1,0.7-2.1,1.3-3.3,1.6l1.3,4.8c2.2-0.4,4.3-1.4,5.9-2.9c2.7-2.3,4.7-6,7.8-14.4l5.6-15.3h-6.1l-3.5,12 c-0.4,1.5-0.8,3.1-1.2,4.4h-0.1c-0.3-1.3-0.8-3-1.2-4.4l-4-12L276.8,33.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.2012,
    y1: 585.5,
    x2: 29.2012,
    y2: 534.44,
    gradientTransform: "matrix(1 0 0 1 0 -518)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9F94F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DAFC6D"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42,33.8c-12.8,5.9-26.6,9.5-40.7,10.5H0.6c-0.1-0.8-0.2-1.7-0.2-2.6c0,0-2.2-22.1,13.3-25.8 c0,0,4.7-1.7,10.2,1.6c1.6,0.8,3.3,1.2,5,1.4c2,0.2,4-0.1,5.9-0.9h-0.1c0.7-0.3,1.1-0.5,1.1-0.5c5.6-3.3,10.2-1.6,10.2-1.6 c4.8,1.1,8.8,4.5,10.7,9.1l-0.7,0.6C51.6,28.8,46.9,31.5,42,33.8z M43,55.9c5.4-2,10.5-4.6,15.2-7.7c-2.3,8.1-7.5,15-14.7,19.3 c-4.3,2.8-9.9,0.9-9.9,0.9c-1.3-0.4-2.7-0.6-4-0.8c-1.3,0.2-2.7,0.5-4,0.8c0,0-5.5,1.9-9.9-0.9c-2.2-1.3-4.2-2.9-6-4.7 C21.2,62.2,32.3,59.9,43,55.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.0004514202,
    y1: 561.3615,
    x2: 61.176,
    y2: 561.3615,
    gradientTransform: "matrix(1 0 0 1 0 -518)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9F6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9F6E5"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.7,44.7C46.3,55.5,26.7,60.2,9,61.4c-0.3,0-0.6-0.1-0.8-0.4C7,59.3,2.1,52.6,0.1,47.3 c-0.3-0.7,0-1.3,0.8-1.9c-0.2,0.3-0.4,0.9,0.2,0.9c17.7-1.9,40.2-7.3,56.2-19.4c0.4-0.2,0.5-0.8,0.2-1.1c-0.1-0.2-0.3-0.3-0.5-0.3 c0,0,1.6,0,2.1,0.9s2,11.6,2.1,17.6C61.2,44.1,61,44.5,60.7,44.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M8.3,49.3l-1,0.2l-1.2,1.1l0.5,1l0.8-0.7l1.1,4.5l1.2-0.2L8.3,49.3z M23.6,51.3l-2,0.6 c0.8-1.3,1.4-2.5,1.1-3.6c-0.2-0.9-1-1.5-1.9-1.4c-0.2,0-0.3,0-0.5,0.1c-0.6,0.1-1.2,0.5-1.6,1l-0.1,0.2l0.7,0.9l0.2-0.3 c0.2-0.3,0.5-0.5,0.9-0.7c0.4-0.1,0.8,0,1,0.4c0,0.1,0,0.1,0,0.2c0.2,0.7-0.2,1.5-1.2,3.2l-0.5,0.8l0.2,0.7l4-1L23.6,51.3z  M36.2,47.2c-0.2-0.6-0.7-1-1.3-1.2c0.5-0.7,0.4-1.7-0.3-2.2c-0.3-0.2-0.6-0.3-1-0.3c-0.3,0-0.5,0-0.7,0.1c-0.6,0.2-1.1,0.5-1.4,1 l-0.1,0.2l0.7,0.9l0.2-0.3c0.2-0.3,0.5-0.5,0.8-0.6c0.1,0,0.2-0.1,0.3-0.1c0.2,0,0.5,0.2,0.5,0.4c0.1,0.2,0,0.4-0.1,0.6 c-0.2,0.2-0.4,0.3-0.6,0.4l-0.7,0.2l0.3,1l0.7-0.2c0.2-0.1,0.4-0.1,0.6-0.1c0.4,0,0.7,0.2,0.8,0.5c0.1,0.2,0.1,0.4,0,0.6 c-0.1,0.2-0.4,0.4-0.7,0.5c-0.2,0.1-0.4,0.1-0.7,0.1c-0.2,0-0.3,0-0.5-0.1l-0.3-0.1v1.2l0.2,0.1c0.2,0.1,0.4,0.1,0.6,0.1 c0.3,0,0.7-0.1,1-0.2c0.6-0.2,1.1-0.5,1.5-1.1C36.3,48.3,36.4,47.7,36.2,47.2C36.2,47.3,36.2,47.2,36.2,47.2z M48.1,42.8l-0.4-1.1 L47,42.1l-1.3-3.3l-1.2,0.4l-1.1,4.5l0.3,0.8l2.4-0.9l0.5,1.4l1.2-0.5l-0.5-1.4L48.1,42.8z M44.8,42.9l0.5-1.8l0.5,1.4L44.8,42.9z  M58.4,37.3c-0.3-0.6-0.9-1.1-1.6-1.1c-0.5,0-0.9,0.1-1.4,0.3l-0.1,0.1l-0.3-0.8l2-0.9l-0.5-1.1l-2.9,1.4l1,3.1L55,38 c0.2-0.1,0.4-0.2,0.6-0.3c0.3-0.1,0.5-0.2,0.8-0.2c0.4,0,0.7,0.2,0.8,0.5c0.2,0.5,0,1.1-0.5,1.3c0,0,0,0,0,0 c-0.3,0.1-0.6,0.2-0.9,0.2h-0.2h-0.3l0.1,1.1h0.2h0.3c0.4,0,0.8-0.1,1.2-0.3c0.6-0.3,1-0.7,1.3-1.3C58.6,38.5,58.6,37.8,58.4,37.3 L58.4,37.3z M10.2,56.9l-1.2,0.1l1.3,4.2l1.2-0.1L10.2,56.9z M22.9,54.8L21.7,55l1.2,4.7l1.2-0.2L22.9,54.8z M35.9,51.6l-1.2,0.4 l1.5,4.7l1.2-0.4L35.9,51.6z M48.2,47.1L47,47.6l1.7,4.2l1.1-0.5L48.2,47.1z M58.4,41.9l-1.1,0.7l1.2,3.7c0.3-0.2,0.7-0.5,1-0.7 L58.4,41.9z M17.3,58.4L16,58.6l0.6,2l1.2-0.2L17.3,58.4z M43.1,51.8L42,52.2l0.8,2.1l1.1-0.5L43.1,51.8z M30.5,55.6l-1.2,0.3 l0.7,2.3l1.2-0.3L30.5,55.6z M54.5,46.3c-0.3,0.2-0.8,0.4-1.1,0.6l0.7,2.1c0.4-0.2,0.7-0.4,1.1-0.6L54.5,46.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.1806,
    y1: 537.894,
    x2: 44.1872,
    y2: 516.4821,
    gradientTransform: "matrix(1 0 0 1 0 -518)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3F42B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C5FA57"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M32,17c0,0-2.2-13,11.4-17C43.5,0,45.8,12,32,17z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.8846,
    y1: 535.0228,
    x2: 25.5546,
    y2: 524.4528,
    gradientTransform: "matrix(1 0 0 1 0 -518)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB9948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6A14B"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M28.4,17.1c0,0-2.1-6.1-6.2-7.7l4.5-3.3c2.7,3.1,3.9,7.2,3.5,11.3C29.6,17.5,29,17.4,28.4,17.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMain);
export default __webpack_public_path__ + "static/media/logoMain.01b8a7fc5276f19ccb69436fccc6dacd.svg";
export { ForwardRef as ReactComponent };